/**
 *    @author:
 *    @since:
 *
 */

import { Component} from '@angular/core';
import { Path } from 'src/app/_common/constant/page-const';

@Component({ 
      selector: 'addtional-doc',
      templateUrl: './addtional-doc.component.html',
      styleUrls: ['./addtional-doc.component.less']
})
export class AddtionalDocComponent  {

      orgContactPath = Path.ORGContactInformation;
      constructor( ) {
      }
}
